import {
  GET_USER_CONTRACT_REQUEST,
  GET_USER_CONTRACT_SUCCESS,
  GET_USER_CONTRACT_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_CONTRACT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_USER_CONTRACT_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_USER_CONTRACT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
